import VisualMemoryEngine from "../../VisualMemory/engine/VisualMemoryEngine";
import { randomInt } from "../../functions";
import Tile from "../../VisualMemory/engine/Tile";

export default class SequenceMemoryEngine extends VisualMemoryEngine {

    sequence: number[];

    constructor() {
        super();
        this.sequence = [];
    }

    initGame(remake?: boolean) {
        this.tiles = [];
        if (this.config.level === 1) {
            this.sequence = [];
        }
        if (!remake) {
            for (let i = this.config.level - 1; i < this.config.level; i++) {
                let randNum = -1;
                while (randNum === -1 || this.sequence[this.sequence.length - 1] === randNum) {
                    console.log(randNum);
                    randNum = randomInt(0, (this.config.width * this.config.height) - 1);
                }
                this.sequence.push(randNum);
            }
        }
        for (let i = 0; i < this.config.width; i++) {
            for (let j = 0; j < this.config.height; j++) {
                this.tiles.push(new Tile(true, false));
            }
        }
    }
}